import DOMPurify from "dompurify";

export default function sanitizedData(prop: string) {
  return { __html: DOMPurify.sanitize(prop) };
}
